// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { MetamaskAuthMutationDocument, type MetamaskAuthMutation, type MetamaskAuthMutationVariables } from './MetamaskAuthMutation';

export async function getMetamaskAuthMutationClient(variables: MetamaskAuthMutationVariables) {
  return fetchGraphqlClient<MetamaskAuthMutation, MetamaskAuthMutationVariables>(MetamaskAuthMutationDocument, "MetamaskAuthMutation", { variables });
}
export const useMetamaskAuthMutation = (options?: MutationOptions) => useMutation<MetamaskAuthMutation, MetamaskAuthMutationVariables>(getMetamaskAuthMutationClient, options);